{
  "__localization_test_string": "You have reached the maximum number of visits to this provider for {{time_period}}. You can next visit this provider starting {{start_date}}.",
  "app_name": "Plentiful",
  "app_button_ok": "OK",
  "app_button_cancel": "Cancel",
  "app_button_yes": "Yes",
  "app_button_no": "No",
  "app_button_confirm": "Confirm",
  "app_button_try_again": "Try again",
  "rate_the_app": "Rate Plentiful",
  "review_prompt_reset_button": "Reset Review Prompt",
  "app_textview_somethingwentwrong": "Something went wrong!\nPlease, try again",
  "app_button_logout": "Logout",
  "app_today": "Today",
  "app_dialog_clarify_prompt": "Are you sure?",
  "app_personal_edittext_phone": "Phone number",
  "app_personal_edittext_dob": "Date of birth (optional)",
  "app_personal_edittext_firstname": "First name",
  "app_personal_edittext_lastname": "Last name",
  "app_personal_edittext_zipcode": "Zip code",
  "app_pantrykind_food": "Food Pantry",
  "app_servicekind_reservations": "Reservations",
  "app_servicekind_line": "Line",
  "distribution_schedule": "Distribution Schedule",
  "service_type_no_digital_options": "Line Only",
  "service_type_reservation_inline": "Reservations",
  "service_type_allows_pre_registration": "Allows Pre-Registration",
  "app_locationnotavailable": "Location not available",
  "app_generalerror": "Error",
  "app_dialog_loading": "Loading. Please wait…",
  "app_dialog_sms_code_title": "SMS code",
  "app_dialog_sms_code_button_send_new_code": "Send a new code",
  "app_release_id": "Application release identifier",
  "sms_disclaimer": "Msg & data rates may apply. Text STOP to opt out.",
  "fragment_registration_language_textview_title": "Select your preferred language to get started",
  "fragment_registration_language_button_next": "Next",
  "fragment_registration_family_textview_title": "Tell us about your household",
  "fragment_registration_family_textview_adults": "Number of Adults (18–{{senior_age_threshold_minus_one}})",
  "fragment_registration_family_textview_children": "Number of Children (under 18)",
  "fragment_registration_family_textview_seniors": "Number of Seniors ({{senior_age_threshold}}+)",
  "fragment_registration_family_textview_notetitle": "Note:",
  "fragment_registration_family_textview_notecontent": "Help us serve you better by providing details about your household. Please note: don't include yourself in the number of household members you list above.",
  "fragment_registration_family_button_back": "Back",
  "fragment_registration_family_button_next": "Next",
  "fragment_registration_personal_textview_title": "Welcome to your Plentiful Profile",
  "fragment_registration_personal_button_back": "Back",
  "fragment_registration_personal_button_finish": "Finish",
  "fragment_main_tabitem_pantrymap": "Map",
  "fragment_main_tabitem_pantrylist": "List",
  "fragment_main_bottombar_pantries": "Pantries",
  "fragment_main_bottombar_visits": "Visits",
  "fragment_main_bottombar_messages": "Messages",
  "fragment_main_bottombar_profile": "Profile",
  "cell_pantry_short_visit_date": "You're going",
  "fragment_pantrydetail_button_changetime": "Change Time",
  "fragment_pantrydetail_textview_amenities": "Amenities",
  "fragment_pantrydetail_textview_conditions": "Conditions",
  "fragment_pantrydetail_textview_notes": "Pantry notes",
  "fragment_pantrydetail_edittext_message": "Message…",
  "fragment_pantrydetail_button_createreservation": "Schedule a Visit",
  "fragment_pantrydetail_button_schedulevisit": "Schedule Visit",
  "dialog_visittime_textview_nodatesavailable": "No dates available",
  "fragment_visitlist_textview_title": "Visits",
  "fragment_visitlist_textview_zero": "This is where you can manage your upcoming service times. Find a pantry to schedule a visit!",
  "fragment_messagethreadlist_textview_title": "Messages",
  "fragment_messagethreadlist_textview_zero": "No updates yet!\nTo subscribe to updates, go to your favorite pantry's details page and toggle 'Get Updates From This Pantry' found at the bottom of the page.",
  "fragment_profile_textview_title": "Profile",
  "fragment_profile_button_savechanges": "Save changes",
  "fragment_profile_textview_personaldetails": "Personal Details",
  "fragment_profile_textview_language": "Language",
  "fragment_profile_textview_notifications": "Notifications",
  "fragment_profile_switch_receivenotifications": "Push Notifications",
  "receive_notifications_helper": "Receive alerts on your device",
  "fragment_profile_textview_servicedetails": "Service details",
  "fragment_profile_switch_pickupfood": "I Have Someone Else Pick Up My Food",
  "fragment_profile_edittext_pickupname": "Pickup Representative First and Last Name",
  "fragment_profile_edittext_pickupphone": "Pickup Representative Phone Number",
  "textview_baby_supplies": "How many children do you need baby supplies for (diapers, wipes, formula)",
  "fragment_profile_textview_emergencycontact": "Emergency Contact",
  "fragment_profile_edittext_emergencyname": "Emergency Contact First and Last Name",
  "fragment_profile_edittext_emergencyphone": "Emergency Contact Phone",
  "aiq_validation_error_regex_telephone_us": "Phone number is of incorrect format",
  "fragment_profile_textview_changepersonalinfo": "This information can be updated at any Plentiful Food Pantry.",
  "fragment_profile_edittext_feedback": "Feedback…",
  "fragment_profile_toast_feedbacksent": "Feedback sent",
  "baby_supplies": "Baby Supplies",
  "household_size": "Household Size",
  "food_pickup": "Food Pickup",
  "emergency_contact": "Emergency Contact",
  "dialog_app_update_title": "Update available",
  "dialog_app_update_message": "Next version of the app is available in the Google Play Store!",
  "dialog_app_update_button_openplaystore": "Open Play Store",
  "app_invalid_error": "Invalid",
  "no_pantries_available": "No Results Found. Try your search with a different pantry name or clear the search box and move or zoom on the map out to explore areas with Plentiful pantries.",
  "visit_served": "served",
  "visit_not_served": "not served",
  "visit_no_show": "you did not show up",
  "visit_group": "You are in Group {{group_number}}, Come by {{time}}",
  "visit_pre_registered": "You're pre-registered, Join the line between {{from_time}} - {{end_time}}",
  "pick_visit_time": "Pick visit time",
  "received_service_on": "You visited on",
  "service_starts_at": "Service starts at",
  "cancel_visit": "Cancel Visit",
  "confirm_cancel_visit": "Are you sure you want to cancel your visit?",
  "yes_cancel": "Yes, Cancel",
  "send": "Send",
  "reservations_available": "Alert me when I'm able to schedule a visit",
  "service_notification_error": "Something went wrong updating your notification preference. Please try again. Still stuck? Tap Profile then We're Here to Help to contact support.",
  "report_location_issue": "Report an issue with this location",
  "registration_intro": "Welcome to Plentiful! We're here to help you find food pantries near you.",
  "app_personal_edittext_enter_phone": "Enter your phone number",
  "code_sent_to": "An SMS login code was sent to",
  "account_created": "Account created",
  "get_started": "let’s get started!",
  "additional_details": "Additional Information",
  "your_qr_code": "Your Plenti-Pass",
  "id_number": "ID number",
  "personal_details_extra": "Personal information and preferences",
  "settings": "Settings",
  "settings_extra": "Language and Notification settings",
  "not_verified": "Not verified yet",
  "must_be_reverified_by": "Must be reverified by",
  "last_verified_on": "Last time verified on",
  "at": "at",
  "no_visit_options_available": "There are no visit options available for you at the moment. Please check the pantry conditions or contact the pantry.",
  "need_help": "Need Help?",
  "email": "Email",
  "terms_conditions": "End User Agreement",
  "privacy_policy": "Privacy Policy",
  "updates": "Updates",
  "family_details": "Household Details",
  "welcome_to_plentiful": "Welcome to Plentiful!",
  "enter_email_phone": "Signing up let's you make reservations and receive updates for food pantries you visit.\nIf you registered at a food pantry, use that same phone number or email. \nNeed help? Contact us at support@plentiful.org",
  "email_or_phone": "Mobile Number or Email Address",
  "email_address": "Email Address",
  "enter_email": "Enter your email",
  "address": "Address",
  "email_invalid": "Email address is not valid",
  "no_sms_enabled_phone": "Phone number cannot receive text messages",
  "verification_email_sent": "Verification email sent!",
  "check_verification_email": "Check your email and click the button inside to verify your account",
  "email_verification_sent": "We’ve sent you an email. Please click the button in the email to verify your email address.",
  "email_address_purpose": "to receive visit reminders and important updates from Plentiful",
  "sign_up": "Sign Up",
  "sign_in": "Sign In",
  "continue": "Continue",
  "create_password": "Create password",
  "enter_password": "Please enter your password to sign in",
  "password_info_box": "If you forgot your password or you were registered at a pantry without setting a password, then please use the options below to log in with a magic or to reset your password.",
  "reset_password": "Reset password",
  "password": "Password",
  "eight_characters": "at least 8 characters",
  "one_special_character": "at least 1 special character",
  "one_number": "at least one number",
  "submit": "Submit",
  "send_magic_link": "Send Magic Link",
  "magic_link_sent": "A Magic Link is on its way to your inbox.",
  "confirm_magic_link_login": "Confirm Magic Link Login",
  "sign_in_another_way": "Sign in another way",
  "enter_phone": "Please enter your phone number",
  "skip": "Skip",
  "optional": "optional",
  "enter_activation_code": "Please enter your login code",
  "activation_code": "Login code",
  "accept_eula": "I have read and agree to the terms of use and privacy",
  "email_verified": "Email verified",
  "email_verified_details": "Your email address is now verified.",
  "do_not_ask_again": "Do not ask again.",
  "email_in_use": "We already have an account associated with this email. Please use a different email",
  "reset_password_text": "Please enter your email to reset your password",
  "reset_password_sent": "Reset password email sent!",
  "reset_password_sent_text": "If we have an account on file for {{email}}, we’ve sent a link to reset your password,",
  "dob_required": "Date of birth",
  "please_verify": "Please verify phone or email in your profile",
  "open_profile": "Open Profile",
  "send_another_verification_email": "Send another verification email",
  "need_to_change_email": "If you need to change your email address, please contact support@plentifulapp.com.",
  "need_to_change_email_or_phone": "If you need to change your email address or phone number, please contact support@plentifulapp.com.",
  "need_to_change_phone": "If you need to change your phone number, please contact support@plentifulapp.com or visit a pantry.",
  "email_subscription": "Email Subscription",
  "email_subscribed": "Email Subscribed",
  "email_unsubscribed": "Email Unsubscribed",
  "email_subscribed_text": "You have now subscribed {{email}} to Plentiful Emails",
  "email_unsubscribed_text": "You have now unsubscribed {{email}} from Plentiful Emails",
  "here_to_subscribe": "Click here to subscribe to Plentiful Emails",
  "here_to_unsubscribe": "Click here to unsubscribe from Plentiful Emails",
  "unsubscribe": "Unsubscribe",
  "subscribe": "Subscribe",
  "open_profile_text": "Click here to go to your profile",
  "sign_in_text": "Click here to sign in",
  "phone_assigned": "This phone number is already in use. Enter another phone number or go back and sign in with this phone number instead.",
  "email_subscribe": "Email Updates",
  "email_subscribe_helper": "Emails from pantries you visit and Plentiful",
  "message_preferences": "Message Preferences",
  "message_preferences_description": "How would you like to receive visit reminders and updates?",
  "message_method_option_0": "Email & App Notifications",
  "message_method_option_1": "Prefer SMS",
  "message_method_helper_add_phone": "Add your phone number to receive SMS messages",
  "message_method_helper_sms_opt_in": "Text 'START' to PANTRY (726-879) to opt back in to SMS",
  "message_method_helper_add_email": "Add your email to receive email messages",
  "message_method_helper_email_unsub": "You've unsubscribed from emails. Update your email preferences to receive emails.",
  "message_method_helper_add_push": "Download the mobile app to receive push notifications",
  "message_method_helper_enable_push": "Enable notifications in your device settings to receive push notifications",
  "password_error": "Wrong password. Try again, reset your password, or sign in another way",
  "action_required": "Action Required",
  "otp_error": "Code could not be verified",
  "show_more": "Show more",
  "pre_registration": "Registration",
  "show_less": "Show less",
  "reschedule": "Reschedule",
  "view_pantry": "View Pantry Details",
  "next_service_on": "Next service on",
  "add_birthday": "Add Your Birthday To Unlock Your Plenti-Pass",
  "birthday_required": "This pass can be used for quick and easy check-in at pantries.",
  "missed_reservation_on": "You missed your reservation on",
  "delete_account": "Delete Account",
  "delete_explain": "Are you sure you want to delete your account? This will cancel all upcoming pantry visits and delete your account. You will need to register again to use Plentiful.",
  "yes_delete": "Yes, delete",
  "no_cancel": "No, cancel",
  "select_visit_reschedule": "Select the visit you want to reschedule",
  "select_visit_cancel": "Select the visit you want to cancel",
  "search_pantries": "Search Pantries",
  "please_sign_in_or_up": "You'll need a Plentiful account to continue. Plentiful is completely free to use.",
  "sign_in_or_up": "Log In or Sign Up to Continue",
  "country_of_birth_option_AF": "Afghanistan",
  "country_of_birth_option_AX": "Åland Islands",
  "country_of_birth_option_AL": "Albania",
  "country_of_birth_option_DZ": "Algeria",
  "country_of_birth_option_AS": "American Samoa",
  "country_of_birth_option_AD": "Andorra",
  "country_of_birth_option_AO": "Angola",
  "country_of_birth_option_AI": "Anguilla",
  "country_of_birth_option_AQ": "Antarctica",
  "country_of_birth_option_AG": "Antigua and Barbuda",
  "country_of_birth_option_AR": "Argentina",
  "country_of_birth_option_AM": "Armenia",
  "country_of_birth_option_AW": "Aruba",
  "country_of_birth_option_AU": "Australia",
  "country_of_birth_option_AT": "Austria",
  "country_of_birth_option_AZ": "Azerbaijan",
  "country_of_birth_option_BS": "Bahamas",
  "country_of_birth_option_BH": "Bahrain",
  "country_of_birth_option_BD": "Bangladesh",
  "country_of_birth_option_BB": "Barbados",
  "country_of_birth_option_BY": "Belarus",
  "country_of_birth_option_BE": "Belgium",
  "country_of_birth_option_BZ": "Belize",
  "country_of_birth_option_BJ": "Benin",
  "country_of_birth_option_BM": "Bermuda",
  "country_of_birth_option_BT": "Bhutan",
  "country_of_birth_option_BO": "Bolivia",
  "country_of_birth_option_BA": "Bosnia and Herzegovina",
  "country_of_birth_option_BW": "Botswana",
  "country_of_birth_option_BV": "Bouvet Island",
  "country_of_birth_option_BR": "Brazil",
  "country_of_birth_option_IO": "British Indian Ocean Territory",
  "country_of_birth_option_BN": "Brunei Darussalam",
  "country_of_birth_option_BG": "Bulgaria",
  "country_of_birth_option_BF": "Burkina Faso",
  "country_of_birth_option_BI": "Burundi",
  "country_of_birth_option_KH": "Cambodia",
  "country_of_birth_option_CM": "Cameroon",
  "country_of_birth_option_CA": "Canada",
  "country_of_birth_option_CV": "Cape Verde",
  "country_of_birth_option_KY": "Cayman Islands",
  "country_of_birth_option_CF": "Central African Republic",
  "country_of_birth_option_TD": "Chad",
  "country_of_birth_option_CL": "Chile",
  "country_of_birth_option_CN": "China",
  "country_of_birth_option_CX": "Christmas Island",
  "country_of_birth_option_CC": "Cocos (Keeling) Islands",
  "country_of_birth_option_CO": "Colombia",
  "country_of_birth_option_KM": "Comoros",
  "country_of_birth_option_CG": "Congo",
  "country_of_birth_option_CD": "Congo, The Democratic Republic of the",
  "country_of_birth_option_CK": "Cook Islands",
  "country_of_birth_option_CR": "Costa Rica",
  "country_of_birth_option_CI": "Cote D'Ivoire",
  "country_of_birth_option_HR": "Croatia",
  "country_of_birth_option_CU": "Cuba",
  "country_of_birth_option_CY": "Cyprus",
  "country_of_birth_option_CZ": "Czech Republic",
  "country_of_birth_option_DK": "Denmark",
  "country_of_birth_option_DJ": "Djibouti",
  "country_of_birth_option_DM": "Dominica",
  "country_of_birth_option_DO": "Dominican Republic",
  "country_of_birth_option_EC": "Ecuador",
  "country_of_birth_option_EG": "Egypt",
  "country_of_birth_option_SV": "El Salvador",
  "country_of_birth_option_GQ": "Equatorial Guinea",
  "country_of_birth_option_ER": "Eritrea",
  "country_of_birth_option_EE": "Estonia",
  "country_of_birth_option_ET": "Ethiopia",
  "country_of_birth_option_FK": "Falkland Islands (Malvinas)",
  "country_of_birth_option_FO": "Faroe Islands",
  "country_of_birth_option_FJ": "Fiji",
  "country_of_birth_option_FI": "Finland",
  "country_of_birth_option_FR": "France",
  "country_of_birth_option_GF": "French Guiana",
  "country_of_birth_option_PF": "French Polynesia",
  "country_of_birth_option_TF": "French Southern Territories",
  "country_of_birth_option_GA": "Gabon",
  "country_of_birth_option_GM": "Gambia",
  "country_of_birth_option_GE": "Georgia",
  "country_of_birth_option_DE": "Germany",
  "country_of_birth_option_GH": "Ghana",
  "country_of_birth_option_GI": "Gibraltar",
  "country_of_birth_option_GR": "Greece",
  "country_of_birth_option_GL": "Greenland",
  "country_of_birth_option_GD": "Grenada",
  "country_of_birth_option_GP": "Guadeloupe",
  "country_of_birth_option_GU": "Guam",
  "country_of_birth_option_GT": "Guatemala",
  "country_of_birth_option_GG": "Guernsey",
  "country_of_birth_option_GN": "Guinea",
  "country_of_birth_option_GW": "Guinea-Bissau",
  "country_of_birth_option_GY": "Guyana",
  "country_of_birth_option_HT": "Haiti",
  "country_of_birth_option_HM": "Heard Island and Mcdonald Islands",
  "country_of_birth_option_VA": "Holy See (Vatican City State)",
  "country_of_birth_option_HN": "Honduras",
  "country_of_birth_option_HK": "Hong Kong",
  "country_of_birth_option_HU": "Hungary",
  "country_of_birth_option_IS": "Iceland",
  "country_of_birth_option_IN": "India",
  "country_of_birth_option_ID": "Indonesia",
  "country_of_birth_option_IR": "Iran, Islamic Republic Of",
  "country_of_birth_option_IQ": "Iraq",
  "country_of_birth_option_IE": "Ireland",
  "country_of_birth_option_IM": "Isle of Man",
  "country_of_birth_option_IL": "Israel",
  "country_of_birth_option_IT": "Italy",
  "country_of_birth_option_JM": "Jamaica",
  "country_of_birth_option_JP": "Japan",
  "country_of_birth_option_JE": "Jersey",
  "country_of_birth_option_JO": "Jordan",
  "country_of_birth_option_KZ": "Kazakhstan",
  "country_of_birth_option_KE": "Kenya",
  "country_of_birth_option_KI": "Kiribati",
  "country_of_birth_option_KP": "Korea, Democratic People'S Republic of",
  "country_of_birth_option_KR": "Korea, Republic of",
  "country_of_birth_option_KW": "Kuwait",
  "country_of_birth_option_KG": "Kyrgyzstan",
  "country_of_birth_option_LA": "Lao People'S Democratic Republic",
  "country_of_birth_option_LV": "Latvia",
  "country_of_birth_option_LB": "Lebanon",
  "country_of_birth_option_LS": "Lesotho",
  "country_of_birth_option_LR": "Liberia",
  "country_of_birth_option_LY": "Libyan Arab Jamahiriya",
  "country_of_birth_option_LI": "Liechtenstein",
  "country_of_birth_option_LT": "Lithuania",
  "country_of_birth_option_LU": "Luxembourg",
  "country_of_birth_option_MO": "Macao",
  "country_of_birth_option_MK": "Macedonia, The Former Yugoslav Republic of",
  "country_of_birth_option_MG": "Madagascar",
  "country_of_birth_option_MW": "Malawi",
  "country_of_birth_option_MY": "Malaysia",
  "country_of_birth_option_MV": "Maldives",
  "country_of_birth_option_ML": "Mali",
  "country_of_birth_option_MT": "Malta",
  "country_of_birth_option_MH": "Marshall Islands",
  "country_of_birth_option_MQ": "Martinique",
  "country_of_birth_option_MR": "Mauritania",
  "country_of_birth_option_MU": "Mauritius",
  "country_of_birth_option_YT": "Mayotte",
  "country_of_birth_option_MX": "Mexico",
  "country_of_birth_option_FM": "Micronesia, Federated States of",
  "country_of_birth_option_MD": "Moldova, Republic of",
  "country_of_birth_option_MC": "Monaco",
  "country_of_birth_option_MN": "Mongolia",
  "country_of_birth_option_MS": "Montserrat",
  "country_of_birth_option_MA": "Morocco",
  "country_of_birth_option_MZ": "Mozambique",
  "country_of_birth_option_MM": "Myanmar",
  "country_of_birth_option_NA": "Namibia",
  "country_of_birth_option_NR": "Nauru",
  "country_of_birth_option_NP": "Nepal",
  "country_of_birth_option_NL": "Netherlands",
  "country_of_birth_option_AN": "Netherlands Antilles",
  "country_of_birth_option_NC": "New Caledonia",
  "country_of_birth_option_NZ": "New Zealand",
  "country_of_birth_option_NI": "Nicaragua",
  "country_of_birth_option_NE": "Niger",
  "country_of_birth_option_NG": "Nigeria",
  "country_of_birth_option_NU": "Niue",
  "country_of_birth_option_NF": "Norfolk Island",
  "country_of_birth_option_MP": "Northern Mariana Islands",
  "country_of_birth_option_NO": "Norway",
  "country_of_birth_option_OM": "Oman",
  "country_of_birth_option_PK": "Pakistan",
  "country_of_birth_option_PW": "Palau",
  "country_of_birth_option_PS": "Palestinian Territory, Occupied",
  "country_of_birth_option_PA": "Panama",
  "country_of_birth_option_PG": "Papua New Guinea",
  "country_of_birth_option_PY": "Paraguay",
  "country_of_birth_option_PE": "Peru",
  "country_of_birth_option_PH": "Philippines",
  "country_of_birth_option_PN": "Pitcairn",
  "country_of_birth_option_PL": "Poland",
  "country_of_birth_option_PT": "Portugal",
  "country_of_birth_option_PR": "Puerto Rico",
  "country_of_birth_option_QA": "Qatar",
  "country_of_birth_option_RE": "Reunion",
  "country_of_birth_option_RO": "Romania",
  "country_of_birth_option_RU": "Russian",
  "country_of_birth_option_RW": "RWANDA",
  "country_of_birth_option_SH": "Saint Helena",
  "country_of_birth_option_KN": "Saint Kitts and Nevis",
  "country_of_birth_option_LC": "Saint Lucia",
  "country_of_birth_option_PM": "Saint Pierre and Miquelon",
  "country_of_birth_option_VC": "Saint Vincent and the Grenadines",
  "country_of_birth_option_WS": "Samoa",
  "country_of_birth_option_SM": "San Marino",
  "country_of_birth_option_ST": "Sao Tome and Principe",
  "country_of_birth_option_SA": "Saudi Arabia",
  "country_of_birth_option_SN": "Senegal",
  "country_of_birth_option_CS": "Serbia and Montenegro",
  "country_of_birth_option_SC": "Seychelles",
  "country_of_birth_option_SL": "Sierra Leone",
  "country_of_birth_option_SG": "Singapore",
  "country_of_birth_option_SK": "Slovakia",
  "country_of_birth_option_SI": "Slovenia",
  "country_of_birth_option_SB": "Solomon Islands",
  "country_of_birth_option_SO": "Somalia",
  "country_of_birth_option_ZA": "South Africa",
  "country_of_birth_option_GS": "South Georgia and the South Sandwich Islands",
  "country_of_birth_option_ES": "Spain",
  "country_of_birth_option_LK": "Sri Lanka",
  "country_of_birth_option_SD": "Sudan",
  "country_of_birth_option_SR": "Suriname",
  "country_of_birth_option_SJ": "Svalbard and Jan Mayen",
  "country_of_birth_option_SZ": "Swaziland",
  "country_of_birth_option_SE": "Sweden",
  "country_of_birth_option_CH": "Switzerland",
  "country_of_birth_option_SY": "Syrian Arab Republic",
  "country_of_birth_option_TW": "Taiwan, Province of China",
  "country_of_birth_option_TJ": "Tajikistan",
  "country_of_birth_option_TZ": "Tanzania, United Republic of",
  "country_of_birth_option_TH": "Thailand",
  "country_of_birth_option_TL": "Timor-Leste",
  "country_of_birth_option_TG": "Togo",
  "country_of_birth_option_TK": "Tokelau",
  "country_of_birth_option_TO": "Tonga",
  "country_of_birth_option_TT": "Trinidad and Tobago",
  "country_of_birth_option_TN": "Tunisia",
  "country_of_birth_option_TR": "Turkey",
  "country_of_birth_option_TM": "Turkmenistan",
  "country_of_birth_option_TC": "Turks and Caicos Islands",
  "country_of_birth_option_TV": "Tuvalu",
  "country_of_birth_option_UG": "Uganda",
  "country_of_birth_option_UA": "Ukraine",
  "country_of_birth_option_AE": "United Arab Emirates",
  "country_of_birth_option_GB": "United Kingdom",
  "country_of_birth_option_US": "United States",
  "country_of_birth_option_UM": "United States Minor Outlying Islands",
  "country_of_birth_option_UY": "Uruguay",
  "country_of_birth_option_UZ": "Uzbekistan",
  "country_of_birth_option_VU": "Vanuatu",
  "country_of_birth_option_VE": "Venezuela",
  "country_of_birth_option_VN": "Viet Nam",
  "country_of_birth_option_VG": "Virgin Islands, British",
  "country_of_birth_option_VI": "Virgin Islands, U.S.",
  "country_of_birth_option_WF": "Wallis and Futuna",
  "country_of_birth_option_EH": "Western Sahara",
  "country_of_birth_option_YE": "Yemen",
  "country_of_birth_option_ZM": "Zambia",
  "country_of_birth_option_ZW": "Zimbabwe",
  "gender_option_female": "Female",
  "gender_option_male": "Male",
  "gender_option_nonconf": "Gender Non-Conforming",
  "relationship_status_option_single": "Single",
  "relationship_status_option_domestic_partner": "Domestic Partner",
  "relationship_status_option_common_law": "Common Law",
  "relationship_status_option_emancipated_minor": "Emancipated Minor",
  "relationship_status_option_married": "Married",
  "relationship_status_option_divorced": "Divorced",
  "relationship_status_option_separated": "Separated",
  "relationship_status_option_widowed": "Widowed",
  "housing_option_own": "Own",
  "housing_option_room_in_apartment": "Room in apartment",
  "housing_option_friends_or_family": "Friends or family",
  "housing_option_regular_rent": "Regular rent",
  "housing_option_subsidized_rent": "Subsidized Rent",
  "housing_option_shelter": "Shelter",
  "housing_option_homeless": "Homeless",
  "employment_option_full_time": "Full time",
  "employment_option_part_time": "Part time",
  "employment_option_unemployed": "Unemployed",
  "education_option_no_high_school": "No High School",
  "education_option_high_school_diploma": "High School diploma",
  "education_option_ged": "GED",
  "education_option_associate_or_bachelo": "Associate or Bachelors degree",
  "education_option_post_graduate": "Post-graduate studies",
  "ethnicity_option_two_or_more_races": "Two or more races",
  "ethnicity_option_black": "Black (non-hispanic)",
  "ethnicity_option_white": "White (non-hispanic)",
  "ethnicity_option_hispanic_or_latino": "Hispanic or Latino",
  "ethnicity_option_asian_or_pacific": "Asian or Pacific Islander",
  "ethnicity_option_american_indian_or_alaskan": "American Indian or Alaskan",
  "ethnicity_option_other": "Other",
  "snap_benefits": "Supplemental Nutrition Assistance Program",
  "wic_benefits": "Supplemental Nutrition Program for Women, Infants, and Children",
  "tanf_benefits": "Temporary Assistance for Needy Families",
  "medicaid_benefits": "Public health insurance for people with low income",
  "ssi_benefits": "Supplemental Security Income program",
  "free_reduced_meals": "Free or Reduced meal program",
  "tefap_form": "TEFAP Attestation",
  "tefap_form_expired": "Your TEFAP Attestation expired on",
  "tefap_form_usda_title": "USDA Non discrimination Statement",
  "tefap_form_usda_subheader": "Please be made aware of the following",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "Next",
  "app_button_back": "Back",
  "app_button_submit": "Submit",
  "app_button_close": "Close",
  "app_button_done": "Done",
  "form_required": "Required *",
  "benefits": "Benefit Programs",
  "benefits_extra": "Details about benefit programs",
  "help_and_support": "We're Here to Help",
  "help_and_support_extra": "FAQs and Contact Information",
  "frequently_asked_questions": "Frequently Asked Questions",
  "contact_support": "Contact Plentiful Support",
  "optional_details": "Optional Details",
  "address_street_1": "Street Address",
  "address_street_2": "Apt",
  "city": "City",
  "state": "State",
  "zipcode": "Zipcode",
  "additional_optional_details": "Additional Details",
  "gender": "Gender",
  "relationship_status": "Relationship Status",
  "ethnicity": "Ethnicity",
  "country_of_birth": "Country of Birth",
  "employment": "Employment",
  "highest_education_obtained": "Education",
  "food_preferences": "Food Preferences",
  "housing_details": "Housing Details",
  "housing_status": "Housing Status",
  "special_circumstances": "Special Circumstances",
  "needs_assistance": "I need assistance at pantries",
  "dont_need_assistance": "I do not need assistance at pantries",
  "aiq_validation_error_min_adult_family_members": "Adult Household Members must be greater than 0",
  "aiq_validation_error_max_adult_family_members": "Adult Household Members cannot be greater than 10",
  "aiq_validation_error_min_child_family_members": "Child Household Members must be greater than 0",
  "aiq_validation_error_max_child_family_members": "Child Household Members cannot be greater than 10",
  "aiq_validation_error_min_senior_family_members": "Senior Household Members must be greater than 0",
  "aiq_validation_error_max_senior_family_members": "Senior Household Members cannot be greater than 10",
  "aiq_validation_error_required_emergency_contact": "Emergency Contact info is required",
  "aiq_validation_error_required_pick_up_name": "Pick Up Representative Name info is required",
  "aiq_validation_error_required_birth_date": "Birth Date info is required",
  "aiq_validation_error_regex_zip_code": "Zip Code must be numeric",
  "aiq_validation_error_required_first_name": "First Name is required",
  "aiq_validation_error_required_last_name": "Last Name is required",
  "aiq_validation_error_min_baby_supplies": "Baby Supplies must be greater than 0",
  "aiq_validation_error_max_baby_supplies": "Baby Supplies cannot be greater than 10",
  "dietary_preferences_option_lactose": "Lactose Intolerance",
  "dietary_preferences_option_gluten": "Gluten Intolerance",
  "dietary_preferences_option_kosher": "Kosher",
  "dietary_preferences_option_halal": "Halal",
  "dietary_preferences_option_dairy_free": "Dairy free",
  "dietary_preferences_option_vegetarian": "Vegetarian",
  "dietary_preferences_option_vegan": "Vegan",
  "dietary_preferences_option_fodmap": "FODMAP",
  "dietary_preferences_option_nut_allergy": "Tree nut and peanut allergies",
  "dietary_preferences_option_fish_allergy": "Fish and shellfish allergies",
  "dietary_preferences_option_none": "No Preferences",
  "tefap_additional_info_requested": "Additional information requested",
  "tefap_zipcode_correct": "Is your zip code correct?",
  "tefap_address_correct": "Is your address correct?",
  "tefap_participate_in_programs": "Does anyone in your household participate in any of the following programs? ",
  "tefap_check_all_that_apply": "Please check all that apply, if none, tap next for more options.",
  "tefap_household_numbers_correct": "Are the number of people in your household correct?",
  "tefap_household_dont_include_yourself": "Please do not include yourself on this screen. TEFAP only requires your total household size, but Plentiful is displaying the information you provided previously.",
  "tefap_income_at_or_below_question": "Is your income at or below",
  "tefap_for_household_size": "for your household of",
  "tefap_retake_attestation": "Do you want to retake the Attestation?",
  "tefap_attestation_completed": "You have successfully completed the TEFAP Attestation form. This is the end of the TEFAP Attestation Section, any further prompts are from Plentiful. ",
  "tefap_thank_you": "Thank you!",
  "tefap_is_recorded": "Your TEFAP attestation has been recorded. You can retake it in your profile.",
  "tefap_sign_below": "Your Name (Optional)",
  "tefap_legal_signing": "By signing below, I declare that my income from all sources does not exceed the income listed above for households with the same number of people as my household OR that my household participates in the program(s) that I have checked on this form. I understand that these records will be held in confidence at this distribution site but may be released to the New York State Office of General Services or the United States Department of Agriculture for review upon their request.",
  "tefap_retake": "Retake",
  "program_complete_now": "Complete now",
  "program_complete_later": "Complete at Pantry",
  "reservation_confirmed": "Visit Confirmed",
  "tefap_reservation_confirmed": "Your Visit is Confirmed!",
  "pre_registration_confirmed": "Visit Confirmed",
  "your_upcoming_reservation": "Your Upcoming Visit",
  "your_upcoming_pre_registration": "Your Upcoming Visit",
  "tefap_attestation_needed": "This pantry is also requesting a TEFAP Attestation.",
  "tefap_attestation_complete_now": "Complete it now and save time at your next pantry visit, or complete at the pantry.",
  "tefap_description": "Through The Emergency Food Assistance Program (TEFAP), the USDA provides food support to your local community, making it available to you through community agencies like soup kitchens and food pantries.",
  "tefap_what_is_tefap": "Learn more about TEFAP here",
  "tefap_confirm_share_with_pantry": "Please confirm you want to share the following information with this pantry.",
  "tefap_thanks_for_sharing": "Thank you for providing the additional information requested by the pantry!",
  "tefap_continue_make_reservation": "Continue Scheduling a Visit",
  "tefap_pantry_is_requesting": "This pantry is requesting your",
  "tefap_missing_information": "Missing Information",
  "tefap_pantry_will_ask": "Click 'Next' to add this information now. If you skip it, the pantry will ask for it at your next visit.",
  "tefap_submission_pending": "Submitting your answers to the pantry...",
  "cancel_edit": "Cancel Edit",
  "edit": "Edit",
  "select": "Select",
  "can_prepare_food": "Can prepare food",
  "cannot_prepare_food": "Cannot prepare food",
  "pantry_details_prompt_title": "{{programName}} needed",
  "pantry_details_prompt_without_visit_label": "This pantry is using {{programName}} for intake. You will have additional questions to answer when you reach the pantry.",
  "pantry_details_prompt_visit_label": "This pantry is using {{programName}} for intake. Save time at your next visit by answering these questions online.",
  "state_program_attestation_cannot_complete": "We're sorry, but we're unable to complete your attestation at this time. You can try again later, contact support, or complete this when you arrive at the pantry.",
  "state_program_attestation_submitted": "Thank you for completing the {{programName}} attestation! Your answers have been successfully submitted to the pantry. This is the end of the {{programName}} questions, and any further prompts are from other Plentiful programs.",
  "state_program_cancel_confirmation": "Are you sure you want to cancel your attestation for {{programName}}? You may still need to answer these questions when you visit the pantry.",
  "state_program_cancel_attestation": "Cancel Attestation",
  "state_program_resume_attestation": "Resume Attestation",
  "tefap_no_submit": "No, submit",
  "tefap_yes_retake": "Yes, retake",
  "tefap_expires": "Expires",
  "tefap_incomplete": "Incomplete, complete now to save time at your next pantry visit",
  "tefap_none": "None",
  "tefap_benefit_programs_select": "Select your enrollment in the following programs",
  "tefap_pantry_requests_info": "This pantry is requesting additional information for your upcoming visit.",
  "tefap_eligible": "You are eligible",
  "tefap_not_eligible": "You are not eligible",
  "tefap_receive_product": "to receive TEFAP product",
  "tefap_eligible_program": "you participate in the following program",
  "tefap_eligible_programs": "you participate in the following programs",
  "tefap_not_eligible_program": "you do not participate in any programs",
  "tefap_household_income": "your household income for",
  "tefap_info_changed": "Has your TEFAP eligibility information (participation in benefit programs, household size and/or income) recently changed?",
  "tefap_still_get_food": "You can still receive non-TEFAP food from pantry.",
  "tefap_form_checking_here": "By checking here, you attest that the following is true:",
  "tefap_form_checking_1": "1. The recipient’s name, address and household size provided above is correct.",
  "tefap_form_checking_2_CO": "2. The recipient resides within Colorado (there is no minimum length of residency required).",
  "tefap_form_checking_2_NY": "2. The recipient resides within New York State (there is no minimum length of residency required).",
  "tefap_form_checking_3": "3. The recipient meets Option 1 and/or Option 2 of TEFAP eligibility guidelines above.",
  "tefap_form_checking_4": "4. This food is for the recipient’s home consumption only, and will not be sold, traded or bartered.",
  "tefap_form_checking_5_1": "5. The recipient is aware of their civil rights as described in the",
  "tefap_form_checking_5_2": "USDA Nondiscrimination Statement.",
  "tefap_out_of_state": "you live in a different state",
  "and": "and",
  "or": "or",
  "exceeds": "is not below",
  "not_exceeds": "does not exceed",
  "people": "people",
  "person": "person",
  "because": "because",
  "custom_field_first_name": "First Name",
  "custom_field_last_name": "Last Name",
  "custom_field_contact_info": "Contact Info",
  "custom_field_birth_date": "Birthday",
  "custom_field_zip_code": "Zip code",
  "custom_field_household_size": "Houshold Size",
  "custom_field_food_pickup": "Pickup Representative",
  "custom_field_emergency_contact": "Emergency Contact",
  "custom_field_address": "Address",
  "custom_field_needs_assistance": "Special Circumstances (Needs Assistance)",
  "custom_field_benefits_programs": "Benefits Programs",
  "custom_field_tefap_income_eligibility": "TEFAP Income Eligibility",
  "custom_field_relationship_status": "Relationship Status",
  "custom_field_ethnicity": "Ethnicity",
  "custom_field_education": "Highest Education Obtained",
  "custom_field_dietary_preferences": "Dietary Preferences",
  "custom_field_gender": "Gender",
  "custom_field_country_of_birth": "Country of Birth",
  "custom_field_employment": "Employment",
  "custom_field_food_preparation": "Can Prepare Food",
  "custom_field_housing": "Housing Status",
  "search": "Search (Pantry Name, Zip, City, State)",
  "all": "all",
  "pantry_filter_program_type": "Program Type",
  "pantry_filter_program_type_non-food": "Non-Food",
  "pantry_filter_program_type_foodpantry": "Food Pantry (free groceries)",
  "pantry_filter_program_type_soupkitchen": "Soup Kitchen (free hot meals)",
  "pantry_filter_status": "Status",
  "pantry_filter_status_all": "All",
  "pantry_filter_status_opennow": "Open Now",
  "pantry_filter_status_opentoday": "Open Today",
  "pantry_filter_status_openthisweek": "Open This Week",
  "pantry_filter_status_other": "Other",
  "pantry_filter_pantry_type": "Pantry Type",
  "pantry_filter_pantry_type_plentifulpantry": "Plentiful Pantry",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "Verified Partner Pantry",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "Unverified Partner Pantry",
  "search_no_results_found": "No results found",
  "search_no_pantries_match": "No pantries match \"{query}\"",
  "search_try_searching_by": "Try searching by:",
  "search_suggestion_city": "City name (e.g., \"Brooklyn\")",
  "search_suggestion_city_accessibility": "City name, for example, Brooklyn",
  "search_suggestion_zipcode": "Zip code (e.g., \"10001\")",
  "search_suggestion_zipcode_accessibility": "Zip code, for example, 10001",
  "search_suggestion_pantry_name": "Pantry name",
  "search_suggestion_street_address": "Street address",
  "search_accessibility_no_results": "No results found for {query}. Try searching by city name, zip code, pantry name, or street address.",
  "search_accessibility_no_results_generic": "No results found. Try searching by city name, zip code, pantry name, or street address.",
  "search_accessibility_no_results_sites": "No results found for {query}. Try searching by pantry name or city.",
  "search_accessibility_no_results_sites_generic": "No results found. Try searching by pantry name or city.",
  "search_error_unable_to_display": "Unable to display search results",
  "search_error_occurred": "An error occurred while displaying your search results. Please try searching again.",
  "search_results_truncated": "Showing top results. Try a different search if you don't see what you're looking for.",
  "accessibility_phone": "Phone: {phone}",
  "accessibility_email": "Email: {email}",
  "accessibility_website": "Website: {website}",
  "pantry_filter_service_type": "Service Type",
  "pantry_filter_service_type_line": "Line-Based",
  "pantry_filter_service_type_pre-registration": "Pre-Registration",
  "pantry_filter_service_type_qr-code": "QR Code Check-In",
  "pantry_filter_service_type_reservation": "Reservation",
  "program_type_benefit_enrollment": "Benefit Enrollment",
  "program_type_emergency_services": "Emergency Services",
  "program_type_non_plentiful_pantry": "Non-Plentiful Pantry",
  "program_type_other_services": "Other Services",
  "program_type_plentiful_pantry": "Plentiful Pantry",
  "program_type_shelter": "Shelter",
  "program_type_soup_kitchen": "Soup Kitchen",
  "service_restriction_none": "No restrictions",
  "service_restriction_seniors": "Seniors Only",
  "service_restriction_families_with_children": "Families with Children Only",
  "service_restriction_new_clients": "New Clients Only",
  "service_restriction_existing_clients": "Existing Clients Only",
  "filter_by_category": "Filter by category",
  "opted_out": "It seems that your phone number opted-out of SMS so we cannot send you your login code. Please opt back in by texting START to 726879 and then try again",
  "miles_away_singular": "%s mile away",
  "miles_away_plural": "%s miles away",
  "today": "today",
  "address_autocomplete_placeholder": "Begin typing to see suggestions",
  "push_notification_permissions_denied": "Permissions not granted for push notifications. Please open your system settings and enable push notifications.",
  "push_notification_setup_error": "There was an error setting up push notifications.",
  "push_notification_alternate_notifications": "You will still receive notifications via SMS or email.",
  "loading_message": "Finding food pantries near you",
  "location_services_no_access": "Plentiful doesn't seem to have access to your device's location. Please enable location services for Plentiful in your browser or device settings.",
  "error_screen_header": "Oops! Something went wrong.",
  "error_screen_message": "We ran into an unexpected issue. You can try to restart the app or contact support.",
  "update_available_header": "Update available",
  "update_available_message": "Restart to load the latest version.",
  "restart_app": "Restart App",
  "email_support": "Email Support",
  "map_zoom_to_see_all": "Zoom in to see all locations",
  "program_eligible": "You are eligible for {{program}}.",
  "program_ineligible": "You are ineligible for {{program}}: {{reason}}",
  "program_not_applicable": "You have completed {{program}}.",
  "program_completed": "You have completed all {{program}} questions.",
  "program_unknown_eligibility": "Thanks for completing the form. The provider will determine your eligibility when you arrive.",
  "site_map_error_title": "Something went wrong",
  "site_map_error_message": "We couldn't load the map. Please try again.",
  "site_map_load_error_title": "Unable to load sites",
  "site_map_load_error_message": "Something went wrong loading this area. Please try again.",
  "site_map_retry": "Retry",
  "site_list_search_placeholder": "Search pantry name, ZIP, city",
  "site_list_result_count": "{{count}} locations",
  "site_list_result_count_one": "{{count}} location",
  "site_list_result_count_zero": "No locations found",
  "site_list_today": "Today",
  "site_list_tomorrow": "Tomorrow",
  "site_list_status_open_until": "Open now until {{time}}",
  "site_list_status_open_now": "Open now",
  "site_list_status_closed_next_open": "Closed now · next open {{day}} {{time}}",
  "site_list_status_no_upcoming": "No upcoming services",
  "site_list_status_more_available": "More times may be available · check with the pantry",
  "site_list_booking_walkin": "Walk in",
  "site_list_booking_reservation": "Reservation",
  "site_list_booking_preregistration": "Pre-registration",
  "site_list_booking_unknown": "Unknown",
  "site_list_more_times": "+ more times available",
  "site_list_default_event_name": "Food Distribution",
  "site_list_unconfirmed_title": "Hours not confirmed",
  "site_list_unconfirmed_body": "We list this place from a partner directory but don't have its current times. Call before you go.",
  "site_list_timezone_note": "Times shown in {{zone}}",
  "site_details_upcoming_events_heading": "Upcoming services",
  "site_details_reserve_cta": "Reserve a time",
  "site_details_plan_visit_cta": "Plan your visit",
  "site_details_no_upcoming_events": "No upcoming services",
  "site_details_timezone_note": "Times shown in {{zone}}",
  "site_details_more_windows": "+ more times available",
  "site_details_event_name_fallback": "Distribution",
  "site_details_slot_picker_no_times": "No times available",
  "site_details_slot_full": "Full",
  "site_details_availability_as_of": "Availability as of {{time}}",
  "site_details_availability_error": "We couldn't load times. Please try again."
}
